<p>ui-admin-pages works!</p>
